import { makeEventFunctions } from '@deephaven/golden-layout';
export var LinkerEvent = Object.freeze({
  LINK_POINT_SELECTED: 'LinkerEvent.LINK_POINT_SELECTED',
  SOURCE_DATA_SELECTED: 'LinkerEvent.SOURCE_DATA_SELECTED',
  REGISTER_TARGET: 'LinkerEvent.REGISTER_TARGET'
});
var linkPointSelectedFns = makeEventFunctions(LinkerEvent.LINK_POINT_SELECTED);
export var listenForLinkPointSelected = linkPointSelectedFns.listen;

/**
 * Emit a linker point selected event
 * @param sourceId The source ID for the link point. Typically panel ID or widget ID
 * @param column The column selected as the link point
 * @param options Optional parameters for the link point selection
 * @param options.isAlwaysEnd Whether this link point is always the end of a link
 * @param options.isIsolatedLinker Whether this link point is selected in an isolated linker context
 */
export var emitLinkPointSelected = linkPointSelectedFns.emit;
export var useLinkPointSelectedListener = linkPointSelectedFns.useListener;
var linkSourceDataSelectedFns = makeEventFunctions(LinkerEvent.SOURCE_DATA_SELECTED);
export var listenForLinkSourceDataSelected = linkSourceDataSelectedFns.listen;
export var emitLinkSourceDataSelected = linkSourceDataSelectedFns.emit;
export var useLinkSourceDataSelectedListener = linkSourceDataSelectedFns.useListener;
var registerLinkTargetFns = makeEventFunctions(LinkerEvent.REGISTER_TARGET);
export var listenForRegisterLinkTarget = registerLinkTargetFns.listen;
export var emitRegisterLinkTarget = registerLinkTargetFns.emit;
export var useRegisterLinkTargetListener = registerLinkTargetFns.useListener;
//# sourceMappingURL=LinkerEvent.js.map